export default "__VITE_ASSET__20c1eb41__"